import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import UserIcon from '../common/icons/UserIcon';

import actions from '../../actions';

const CaretDownIcon = props => {
  return (
    <svg
      width="14"
      height="8"
      className={props.className}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.01667 -1.01997e-06L0.5 1.51351L7 8L13.5 1.51351L11.9833 -1.45563e-06L7 4.97297L2.01667 -1.01997e-06Z"
      />
    </svg>
  );
};

CaretDownIcon.propTypes = {
  className: PropTypes.string,
};

const DesktopHeaderUserDropdown = props => {
  const node = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      return;
    }
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const logout = () => {
    dispatch(actions.authLogout());
    history.push('/auth');
  };

  const navigateTo = path => () => {
    history.push(path);
  };

  return (
    <div className="is-flex">
      <div className="tutorium-dropdown" ref={node}>
        <div className="tutorium-dropdown-header" onClick={toggleIsOpen}>
          <div className="is-flex align-items-center mx-15px user-dropdown-container" style={{ height: '70px' }}>
            <UserIcon size={34} className={props.iconClassNames} />
            <CaretDownIcon className={classnames(props.iconClassNames, 'ml-5px')} />
          </div>
        </div>
        {isOpen && (
          <ul className="tutorium-dropdown-menu">
            <li className="tutorium-dropdown-menu-link" onClick={navigateTo('/')}>
              Main
            </li>
            <li className="tutorium-dropdown-menu-link" onClick={navigateTo('/profile')}>
              Profile
            </li>
            <li className="tutorium-dropdown-menu-link" onClick={logout}>
              Sign out
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

DesktopHeaderUserDropdown.propTypes = {
  iconClassNames: PropTypes.string.isRequired,
};

export default DesktopHeaderUserDropdown;
